/*!*
 * @author yueheqin
 * @date 2019/6/19
 * @project zujuanzaixian
 * @desc 帮助中心
 */
export const help = [
  {
    path: '/help',
    name: 'Help',
    redirect: { name: 'HelpAbout' },
    component: () => import('../views/help.vue'),
    meta: { title: '帮助中心' },
    children: [
      {
        path: 'about',
        name: 'HelpAbout',
        component: () => import('../views/help-about.vue'),
        meta: { title: '关于我们' }
      },
      {
        path: 'school',
        name: 'HelpSchool',
        component: () => import('../views/help-school.vue'),
        meta: { title: '使用院校' }
      },
      {
        path: 'center',
        name: 'HelpCenter',
        component: () => import('../views/help-center.vue'),
        meta: { title: '帮助中心' }
      },
      {
        path: 'article/:id',
        name: 'HelpArticle',
        component: () => import('../views/help-article'),
        meta: { title: '教育网址导航' }
      },
      {
        path: 'contact',
        name: 'HelpContact',
        component: () => import('../views/help-contact.vue'),
        meta: { title: '联系我们' }
      },
      // {
      //   path: 'message',
      //   name: 'HelpMessage',
      //   component: () => import('../views/help-message.vue'),
      //   meta: { title: '留言反馈' }
      // },
      {
        path: 'secret',
        name: 'HelpSecret',
        component: () => import('../views/help-secret.vue'),
        meta: { title: '隐私条款' }
      },
      {
        path: 'link',
        name: 'HelpFriendLink',
        component: () => import('../views/help-friend-link.vue'),
        meta: { title: '教育网址导航' }
      }
    ]
  }
]
